import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/api-services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-attendance-logs-with-periods',
  templateUrl: './view-attendance-logs-with-periods.component.html',
  styleUrls: ['./view-attendance-logs-with-periods.component.scss']
})
export class ViewAttendanceLogsWithPeriodsComponent {

  userId: string
  logDate: String; // This will be date
  branchId: string

  attendanceLogsWithPeriods = []

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public apiService: ApiService,
    private toastr: ToastrService
  ){
    this.userId = localStorage.getItem('AttendanceLogPeriodsUserId')
    this.logDate = localStorage.getItem('AttendanceLogPeriodsLogDate')
    this.branchId = localStorage.getItem('AttendanceLogPeriodsBranchId')
  }
  
  ngOnInit(){
    this.getUserAttendanceLogsWithPeriods()
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hr " : " hrs ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " min " : " mins ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
     
    return hDisplay + mDisplay + sDisplay;
   
  }

  getUserAttendanceLogsWithPeriods(){
    let queryParams = {filter_by_branch_id: this.branchId || null}
    let pathParams = {user_id: this.userId, log_date: this.logDate}
    this.apiService.getUserAttendanceLogsWithPeriods(queryParams, pathParams).subscribe((resp) => {
      if (resp.status == "success") {
        this.attendanceLogsWithPeriods = resp.data.attendance_log_with_periods;

        this.attendanceLogsWithPeriods.forEach(logWithPeriods => {
          logWithPeriods.attendance_log_periods.forEach(logPeriod => {
            logPeriod.used_time_in_secs = this.secondsToHms(logPeriod.used_time_in_secs)
            logPeriod.charged_time_in_secs = this.secondsToHms(logPeriod.charged_time_in_secs)
          })
        });
      }
    },
      (err) => {
        this.toastr.error(err.error.message)
      }
    )
  }

  back(){
    localStorage.removeItem('AttendanceLogPeriodsUserId')
    localStorage.removeItem('AttendanceLogPeriodsLogDate')
    localStorage.removeItem('AttendanceLogPeriodsBranchId')
    this.router.navigateByUrl('Admin/view-user-attendance')
  }
}
